import { NString } from 'types'
import { isValid, parseISO } from 'date-fns'

export const getValidDate = (date: NString): Date => {
  const parsedDate = parseISO(date || '')

  return isValid(parsedDate) ? parsedDate : new Date()
}

export const getDaysInMonth = (month: number, year: number): number =>
  new Date(year, month + 1, 0).getDate()

export const getFirstDayOfMonth = (month: number, year: number): number => {
  const day = new Date(year, month, 1).getDay()
  return day === 0 ? 6 : day - 1
}

export const monthNamesRus = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
]

export const dayNamesRus = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
